module.exports = __webpack_public_path__ + "img/saddle_pl_logo.d8373f07.png";